export default __webpack_public_path__ + "c00ddb7b.woff";